<template>
    <div>
        <b-modal
            id="serial_modal"
            modal-class=""
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <p id="headline">{{objSerialMessage.strHeadline}}</p>
                    <div class="modal-base-close" @click="closeSerialModal()">
                        <img
                            class="icon-close"
                            src="../../assets/icon/close@2x.png"
                        />
                    </div>
                </div>
                <!--Show code-->
                <div class="modal-base-body">
                    <div class="serial-block"
                        v-if="objSerialCode.isShowCode && campaign.serial">
                        <div id="serial_tab_wrapper" class="serial-wrapper">
                            <div class="serial-tab"
                                @click="clickChangeTab('QR_CODE')">
                                    <div class="serial-tab-lbl" :class="{'tab-active': objSerialCode.strCodeType === 'QR_CODE'}">{{lblSerial.qr_code}}</div>
                                </div>
                            <div class="serial-tab"
                                @click="clickChangeTab('CODE_128')">
                                    <div class="serial-tab-lbl" :class="{'tab-active': objSerialCode.strCodeType === 'CODE_128'}">{{lblSerial.barcode}}</div>
                                </div>
                            <div class="serial-tab"
                                @click="clickChangeTab('CODE')">
                                    <div class="serial-tab-lbl" :class="{'tab-active': objSerialCode.strCodeType === 'CODE'}">{{lblSerial.code}}</div>
                                </div>
                        </div>
                        <div id="serial_code_wrapper"
                            class="serial-wrapper">
                            <div class="serial-code"
                                v-show="objSerialCode.strCodeType === 'CODE'">
                                <p id="code"
                                    :class="{'long-code': campaign.serial.length > 12, 'serial-expire' : campaign.serial === 'XXXXXXX'}">
                                    {{campaign.serial === 'XXXXXXX' ? 'XXXXXXX' : campaign.serial}}</p>
                            </div>
                            <div class="serial-code"
                                v-show="objSerialCode.strCodeType === 'CODE_128'">
                                <vue-barcode id="barcode"
                                    :value="campaign.serial"
                                    :options="objBarcodeConfig"></vue-barcode>
                            </div>
                            <div class="serial-code"
                                v-show="objSerialCode.strCodeType === 'QR_CODE'">
                                <vue-qrcode id="qrcode"
                                    :value="campaign.serial"
                                    :options="objQrCodeConfig"></vue-qrcode>
                            </div>
                        </div>
                    </div>
                    <!--Not show code-->
                    <div class="serial-block"
                        v-if="!objSerialCode.isShowCode">
                        <div class="serial-wrapper">
                            <p class="serial-privilege-message"
                                v-html="cleanMessage(objSerialMessage.strMessage)"></p>
                        </div>

                    </div>
                </div>
                <!--Timer-->
                <div class="modal-base-footer">
                    <div class="serial-block">

                        <div class="serial-wrapper">
                            <p v-show="!objSerialMessage.strMessage" id="serial_redeem_msg" v-html="lblSerial.serial_msg"></p>
                             <p v-show="objSerialMessage.strMessage" id="serial_redeem_msg" v-html="objSerialMessage.strMessage"></p>
                        </div>
                        <!-- <div class="serial-wrapper">
                            <div class="wrapper-btn-close">
                                <div class="btn btn-close" @click="closeSerialModal('use_later')">{{lblSerial.next_use}}</div>
                            </div>
                        </div> -->
                        <!-- <div class="serial-wrapper">
                            <p id="serial_redeem_on">{{getRedeemDate(campaign.redeemDate)}}</p>
                        </div> -->
                    </div>
                    <div class="serial-block expire">
                        <div class="serial-wrapper-left" v-if="objTimer.isShowTimer"><!-- v-if="objTimer.isShowTimer" -->
                            <p id="serial_expire">
                                <span id="serial_expire_txt">{{lblSerial.expire_in}}</span><br>
                                <span id="serial_expire_time" :class="{'serial-expired': objTimer.isExpired}">{{objTimer.strTimeLeft}}</span></p>
                        </div>
                        <div class="serial-logo">
                            <img src="../../assets/bzbslogo/buzzebees-logo-dark@2x.png" />
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal
            id="privilege_modal"
            modal-class=""
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <p id="headline">{{objSerialMessage.strHeadline}}</p>
                </div>
                <div class="modal-base-body">
                    <div class="serial-block">
                        <div class="serial-wrapper"
                            v-if="objSerialMessage.strMessageType === 'privilege'">
                            <p class="serial-privilege-message"
                                v-html="cleanMessage(this.objSerialMessage.strMessage)"></p>
                            <p class="serial-privilege-message"
                                v-if="campaign.derivered">{{lblSerial.delivery}}</p>
                        </div>
                        <div class="serial-wrapper"
                            v-if="objSerialMessage.strMessageType === 'delivery'">
                            <p id="serial_draw_delivery" class="serial-privilege-message"
                                v-html="cleanMessage(this.objSerialMessage.strMessage)"></p>
                        </div>
                        <div class="serial-logo">
                            <img src="../../assets/bzbslogo/buzzebees-logo-dark@2x.png" />
                        </div>
                    </div>
                </div>
                <div class="modal-base-footer">
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Vue from 'vue';
import moment from "moment";
import Util from '@/helper/Utility.js';
import Moment from 'moment';
import Locale from '@/helper/locale/locale.js';
import DateTime from "@/helper/DatetimeHelper.js";
import VueBarcode from '@chenfengyuan/vue-barcode'; // https://github.com/fengyuanchen/vue-barcode/blob/master/README.md
import VueQrcode from '@chenfengyuan/vue-qrcode'; // https://github.com/fengyuanchen/vue-qrcode

/**
 * Property
 * @property {object} lbl (required) Text for component.
 * @property {object} busSerialModal (required) Modal Controller.
 * Event
 * @event clickChangeTab Change serial code type.
 * Method
 * @method initialSerialModal Setup serial modal with campaign.
 * @method closeSerialModal Stop interval and close modal.
 * Interval
 * @method startInterval Start serial interval.
 * @method stopInterval Stop serial interval.
 * @method serialExpired Set serial modal to expired state.
 * @method initialSerialTimer Setup time information and start interval.
 * @method timeFormatter Format timestamp to count down timer.
 * Utilities
 * @method cleanMessage Replace \n to <br/>
 * @method getRedeemDate Convert time stamp to readable format.
 * @method getDrawMessage Create message for campaign type draw.
 */
export default {
    name: 'SerialModal',
    components: {
        VueBarcode,
        VueQrcode
    },
    props: {
        lbl: Object,
        busSerialModal: Object
    },
    data: function() {
        return {
            campaign: {},
            lblDate: {},
            lblSerial: {},

            interval: null,
            isTabLock: false,
            isRenderComplete: false,
            strSerialType: 'serial', //serial,privilege
            objSerialMessage: {
                strHeadline: '',
                strMessage: '',
                strMessageType: '',
            },
            objSerialCode: {
                isShowCode: true,
                strCodeType: '', //CODE_128,QR_CODE,CODE
            },
            objTimer: {
                isExpired: false,
                isRunning: false,
                isShowTimer: false,
                numCurrentDate: '',
                numExpireDate: '',
                numExpireIn: 0,
                numOriginalDate: 0,
                strTimeLeft: ''
            },
            objBarcodeConfig: {
                width: 1,
                height: 50,
                displayValue: true,
                lineColor: '#000000'
            },
            objQrCodeConfig: {
                width: 150
            }
        };
    },
    mounted: function() {
        this.lblDate = this.lbl.date;
        this.lblSerial = this.lbl.serial;
        this.busSerialModal.$on('showSerialModal', this.initialSerialModal);
        this.busSerialModal.$on('hideSerialModal', this.closeSerialModal);
    },
    methods: {
        //Event
        clickChangeTab: function(strCurrentTab) {
            if (this.isTabLock) return;

            this.objSerialCode.strCodeType = strCurrentTab;
            this.trackEvent();
        },
        trackEvent: function() {
            var label = this.campaign.id + "|" + this.campaign.name;
            var gtm = {
                "event_label": this.campaign.name,
                "privilege_category_name": this.campaign.categoryName,
                "privilege_id": this.campaign.id,
                "transaction_id": this.serial,
                "timestamp": moment().format("YYYYMMDD HH:mm:ss")
            };

            var seenScreen = "";
            if (this.objSerialCode.strCodeType == "CODE") {
                seenScreen = "Code";
            } else if (this.objSerialCode.strCodeType == "CODE_128") {
                seenScreen = "Barcode";
            } else {
                seenScreen = "Qrcode";
            }


            Vue.ga.event(this, "privilege", seenScreen + "_impression_step2", label, null, gtm);
        },
        //End Event
        //Function
        initialSerialModal: function(campaign) {
            this.campaign = Util.normalObject(campaign);
            this.objSerialMessage.strHeadline = this.lblSerial.Headline
            //Clear interval
            if(this.interval)
                this.stopInterval();

            if (this.campaign.delivered === true ||
                this.campaign.type === Vue.CampaignType.Draw)
                this.strSerialType = 'draw_or_delivery';

            //Initial modal type
            switch (this.strSerialType) {
                case 'serial':
                    //Initial serial tab


                    switch (this.campaign.barcode) {
                        case 'CODE_128':
                            this.objSerialCode.strCodeType = 'CODE_128';
                            break;
                        case 'QR_CODE':
                            this.objSerialCode.strCodeType = 'QR_CODE';
                            break;
                        default:
                            if (this.campaign.barcode.toLowerCase() === 'none' &&
                                this.campaign.privilegeMessage)
                                this.objSerialCode.isShowCode = false;

                            this.objSerialCode.strCodeType = 'CODE';
                            break;
                    }

                    //Set privilege message fonmat
                    if (this.campaign.privilegeMessageFormat &&
                        this.campaign.privilegeMessageFormat.toLowerCase() === 'html') {
                        if (this.campaign.privilegeMessage)
                            this.objSerialMessage.strMessage = this.campaign.privilegeMessage;
                    } else {
                        if (this.campaign.privilegeMessage)
                            this.objSerialMessage.strMessage = this.campaign.privilegeMessage;
                        else
                            this.objSerialMessage.strMessage = this.lblSerial.show_code_at_shop;
                    }

                    this.trackEvent();

                    //Set isShowTimer
                    this.initialSerialTimer();

                    this.$bvModal.show('serial_modal');
                    break;
                case 'draw_or_delivery':
                    if(this.campaign.privilegeMessage) {
                        this.objSerialMessage.strMessage = this.campaign.privilegeMessage;
                        this.objSerialMessage.strMessageType = 'privilege';
                    } else {
                        if(this.campaign.delivered === true) {
                            this.objSerialMessage.strMessage = this.lblSerial.delivery;
                            this.objSerialMessage.strMessageType = 'delivery';
                        }

                        if(this.campaign.type === Vue.CampaignType.Draw) {
                            this.objSerialMessage.strMessage = this.getDrawMessage(this.lblSerial.draw);
                            this.objSerialMessage.strMessageType = 'privilege';
                        }
                    }

                    this.$bvModal.show('privilege_modal');
                    break;
            }
        },
        closeSerialModal: function(closeType) {
            var label = "close_redemption";

            if (closeType == "use_later")
                label = "use_later_redemption";

            var gtm = {
                 "event_label": label,
                 "timestamp": DateTime.getDateTimeGTM()
            };

            Vue.ga.event(this, "privilege", "click_buttons", gtm.event_label, null, gtm);

            switch(this.strSerialType) {
                case 'serial':
                    this.stopInterval();
                    this.$bvModal.hide('serial_modal');
                    break;
                case 'draw_or_delivery':
                    this.$bvModal.hide('privilege_modal');
                    break;
            }
            this.$emit('closeSerialModal', {});
        },
        //Timer
        startInterval: function() {
            var self = this;
            this.timeFormatter(true, true);
            this.interval = setInterval(function () {
                self.timeFormatter(true, true);
            }, 1000);
        },
        stopInterval: function() {
            clearInterval(this.interval);
        },
        serialExpired: function() {
            this.objSerialCode.strCodeType = 'CODE';
            this.isTabLock = true;
            this.objTimer.isExpired = true;
            this.objTimer.isRunning = false;
            this.campaign.serial = "XXXXXXX";
            this.campaign.expireIn = -1;

            this.stopInterval();

            this.$emit('serialExpired', {});
        },
        initialSerialTimer: function () {
            if (this.campaign.expireIn) {
                this.objTimer.isShowTimer = true;
                this.objTimer.numCurrentDate = this.campaign.currentDate;
                this.objTimer.numOriginalDate = this.campaign.currentDate;
                this.objTimer.numExpireDate = this.campaign.currentDate + this.campaign.expireIn
                this.objTimer.numExpireIn = this.campaign.expireIn;
                this.startInterval();
            } else {
                this.objTimer.isShowTimer = false;
            }
        },
        timeFormatter: function(isShowDay, isShowHour) {
            var months = Moment.unix(this.objTimer.numExpireDate).diff(Moment.unix(this.objTimer.numCurrentDate), 'months', true);

            var days =  Moment.unix(this.objTimer.numExpireDate).diff(Moment.unix(this.objTimer.numExpireDate).startOf("month"), 'days', true);
            if (months <= 1) {
                days = Moment.unix(this.objTimer.numExpireDate).diff(Moment.unix(this.objTimer.numCurrentDate), 'days', true);
            }

            var numTimeDiff = Moment.unix(this.objTimer.numExpireDate) - Moment.unix(this.objTimer.numCurrentDate);

            //Timer Expired
            if(numTimeDiff <= 0) {
                numTimeDiff = 0;
                this.serialExpired();
            }

            //Add 1 second to current date.
            this.objTimer.numCurrentDate++;

            //Calculate day.
            var numDayDiff = Math.floor(numTimeDiff / 1000 / 60 / 60 / 24);
            //var haveDay = parseInt(numDayDiff) <= 0 ? false : true;
            if(isShowDay)
                numTimeDiff -= numDayDiff * 1000 * 60 * 60 * 24;

            //Calculate hour.
            var numHourDiff = Math.floor(numTimeDiff / 1000 / 60 / 60);
            //var haveHour = parseInt(numHourDiff) <= 0 ? false : true;
            if (isShowHour)
                numTimeDiff -= numHourDiff * 1000 * 60 * 60;

            if (numHourDiff <= 9)
                numHourDiff = "0" + numHourDiff;

            //Calculate minute.
            var numMinuteDiff = Math.floor(numTimeDiff / 1000 / 60);
            //var haveMinute = parseInt(numMinuteDiff) <= 0 ? false : true;
            numTimeDiff -= numMinuteDiff * 1000 * 60;

            if (numMinuteDiff <= 9)
                numMinuteDiff = "0" + numMinuteDiff;

            //Calculate second.
            var numSecondDiff = "" + Math.floor(numTimeDiff / 1000);
            //var haveSecond = parseInt(numSecondDiff) <= 0 ? false : true;
            if (numSecondDiff <= 9)
                numSecondDiff = "0" + numSecondDiff;


            if (months > 1) {
                this.objTimer.strTimeLeft = this.getExpireDate(this.objTimer.numExpireDate);
            } else if (days > 1) {
                this.objTimer.strTimeLeft = days.toString().split(".")[0] + " " + this.lbl.date.days + " " + numHourDiff + " " + this.lbl.date.hours + " " + numMinuteDiff + " " + this.lbl.date.minutes;
            } else if (numHourDiff > 1) {
                this.objTimer.strTimeLeft = numHourDiff + " " + this.lbl.date.hours + " " + numMinuteDiff + " " + this.lbl.date.minutes + " " + numSecondDiff + " "  + this.lbl.date.second;
            } else if (numMinuteDiff > 1) {
                this.objTimer.strTimeLeft = numMinuteDiff + " " + this.lbl.date.minutes + " " + numSecondDiff + " "  + this.lbl.date.second;
            } else {
                this.objTimer.strTimeLeft = numSecondDiff + " "  + this.lbl.date.second;
            }

        },
        //Utility
        cleanMessage: function (message) {
            return Util.newLineToBr(message);
        },
        getExpireDate: function (expireDate) {
            if (!expireDate) return;

            var result = Moment.unix(expireDate).utc();
            var year = Moment.unix(expireDate).utc().format('YYYY');
            if (Locale.getLocaleCode() === 1054) year = result.get('year') + 543;

            var monthString = result.format('MM');
            var strDate = result.format('DD') + "/" + monthString + "/" + year;

            return strDate;
        },
        getRedeemDate: function (redeemDate) {
            if (!redeemDate) return;

            var message = this.lblSerial.redeem_on;
            var result = Moment.unix(redeemDate).utc();
            var year = Moment.unix(redeemDate).utc().format('YYYY');
            if (Locale.getLocaleCode() === 1054) year = result.get('year') + 543;

            var monthString = this.lblDate.month_short[result.format('M') - 1];
            var strDate = result.format('DD') + " " + monthString + " " + year
                        + ' | ' + result.format('HH:mm');

            return Util.stringFormat(message, strDate);
        },
        getDrawMessage: function (message) {
            var expireDate = this.campaign.expireDate;
            var result = Moment.unix(expireDate).utc();
            var year = Moment.unix(expireDate).utc().format('YYYY');
            if (Locale.getLocaleCode() === 1054) year = result.get('year') + 543;

            var monthString = this.lblDate.month_short[result.format('M') - 1];
            var strDate = result.format('DD') + " " + monthString + " " + year
                        + ' | ' + result.format('HH:mm');

            return Util.stringFormat(message, strDate);
        }
    }
};
</script>

<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/base/common.scss";
    .modal-base-head {
        padding: 15px 15px 0px 15px;

        #headline {
            text-align: center;
            font-size: 28px;
            font-weight: bold;
        }

        .modal-base-close {
            position: absolute;
            top: 10px;
            right: 15px;
            width: 18px;

            .icon-close {
                width: 100%;
            }
        }
    }
    .serial-block {
        width: 100%;

        &.expire {
            border-top: 1px solid $primery-color;
        }

        .serial-wrapper {
            width: 100%;


            .serial-privilege-message {
                width: 100%;
                font-size: 1rem;
                text-align: center;

            }

            #serial_draw_delivery {
                margin-top: 10px;
            }

            #serial_expire {
                text-align: center;
            }

            #serial_redeem_on {
                text-align: center;
            }

            #serial_redeem_msg {
                padding: 0 15px;
                text-align: center;
                font-size: 20px;
                font-weight: 500;
                line-height: 1.05;
            }

            .wrapper-btn-close {
                text-align: center;
                margin: 15px 0;
                .btn-close {
                    border: 1px solid $primery-color;
                    padding: 7px 45px;
                    font-size: 22px;
                    font-weight: 500;
                    color: $primery-color;
                }
            }
        }
        .serial-wrapper-left {
            width: 60%;
            float: left;
            padding: 15px 0px 0px 15px;

            #serial_expire {
                line-height: 1;
                #serial_expire_txt {
                    font-size: 20px;
                    font-weight: 500;
                }

                #serial_expire_time {
                    font-size: 22px;
                    font-weight: 500;
                    color: $primery-color;
                }
            }
        }

        .serial-logo {
            width: 40%;
            float: right;
            padding: 15px 15px 15px 20px;
            img {
                width: 100%;
            }
        }

        #serial_tab_wrapper {
            font-size: 0;
            list-style: none;
            white-space: nowrap;
            border-bottom: 1px solid $gray-color;

            .serial-tab {
                display: inline-block;
                width: calc(100% / 3);
                padding: 0;
                white-space: normal;
                font-size: 0;
                position: relative;

                &:nth-child(2) {
                    margin-left: -1px;
                    margin-right: -1px;
                }

                .serial-tab-lbl {
                    position: relative;
                    display: block;
                    padding: 5px 5px 0px 5px;
                    font-size: 22px;
                    font-weight: 500;
                    text-align: center;
                    text-decoration: none;
                    line-height: 1;
                    cursor: pointer;
                    color: $gray-color;

                    &:hover {
                        color: $primery-color;
                    }

                    &.tab-active {
                        border-bottom: 5px solid $primery-color;
                        color: $primery-color;

                        &::before {
                            background: wheat;
                            width: 65%;
                            margin: 0 auto;
                            height: 11px;
                            content: "";
                            display: block;
                            position: absolute;
                            left: 0;
                            right: 0;
                            bottom: 8px;
                            z-index: -1;
                        }
                    }
                }
            }
        }

        #serial_code_wrapper {
            .serial-code {
                @extend %display-flex;
                width: 100%;
                min-height: 150px;

                #code {
                    font-size: 22px;
                    font-weight: bold;
                    &.long-code {
                        font-size: 35px;
                        word-break: break-all;
                        text-align: center;
                        padding: 0 25px;
                    }
                }

                #barcode {
                    max-width: 100%;
                }

                #code, #barcode, #qrcode {
                    margin: auto;
                    
                }
            }
        }
    }
</style>
<style lang="scss">
    #serial_modal {
        .modal-dialog {
            padding: 0 15px;

            .modal-content {
                border-radius: 15px;
                .modal-body {
                    padding: 0;
                }
            }

        }
    }
</style>
